import { useState } from 'react';
import CommandCenterNav from './commandCenterNav';
import WorkspacePreview from './workspace-preview';
import { useGreeting } from '@Hooks/useGreeting';
import { useAuth } from '@Contexts/auth';
import FlowCategoryPreview from './flow-category-preview';
import TopRow from './top-row';
import UpcomingEventsButton from '@Components/UpcomingEventsButton';
import { useTicketedEvents } from '@Hooks/useTicketedEvents';
import { useEventBookingEvents } from '@Hooks/useEventBookingEvents';
import AiChatBar from '@Components/AiChatBar';
import ShowFor from '@Components/ShowFor';

const EVENT_COUNT_DAY_RANGE = 7;

const CommandCenter = () => {
  const [currentAgent, setCurrentAgent] = useState();
  const { user } = useAuth();
  const name = user?.name ?? null;
  const greeting = useGreeting();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const end = new Date(today);
  end.setDate(today.getDate() + EVENT_COUNT_DAY_RANGE);
  end.setHours(23, 59, 59, 999);

  const { data: ticketedEvents } = useTicketedEvents({
    searchParams: {
      'filter[startDateTime][gte]': today.toISOString(),
      'filter[startDateTime][lte]': end.toISOString(),
    },
  });

  const { data } = useEventBookingEvents({
    filters: {
      'filter[startDate][gte]': today.toISOString(),
      'filter[startDate][lte]': end.toISOString(),
    },
  });
  const privateDiningEvents = data?.data;

  return (
    <div>
      <div className="mt-4 flex flex-col gap-10">
        <div className="-mx-8 flex flex-col gap-4 overflow-x-auto">
          <ShowFor permissions={['AI_ACCESS']}>
            <div className="flex w-full min-w-fit justify-center px-8">
              <AiChatBar currentAgent={currentAgent} />
            </div>
          </ShowFor>
          <ShowFor
            permissions={[
              'EVENTS_WRITE',
              'SEGMENTS_WRITE',
              'AI_ACCESS',
              'CAMPAIGNS_WRITE',
              'FLOWS_WRITE',
              'PURCHASES_READ',
            ]}
          >
            <div className="flex w-full min-w-fit justify-center px-8">
              <CommandCenterNav defaultActive="home" compact={false} />
            </div>
          </ShowFor>
        </div>

        <div className="-mx-8 overflow-x-auto">
          <div className="flex min-w-fit justify-between gap-20 px-8">
            <div>
              <span className="text-3xl font-bold whitespace-nowrap">
                {greeting}
                {name ? `, ${name}` : ''}
              </span>
            </div>
            <ShowFor permissions={['EVENTS_READ']}>
              <div className="flex gap-4">
                <UpcomingEventsButton
                  itemCount={
                    Array.isArray(ticketedEvents)
                      ? ticketedEvents?.length
                      : null
                  }
                />
                <UpcomingEventsButton
                  label={'Upcoming PD Events'}
                  icon={'handPlatter'}
                  itemCount={
                    Array.isArray(privateDiningEvents)
                      ? privateDiningEvents.length
                      : null
                  }
                  path={'/private-dining-events'}
                />
              </div>
            </ShowFor>
          </div>
        </div>

        <div className="-mx-8 overflow-x-auto">
          <ShowFor permissions={['AI_ACCESS']}>
            <div className="min-w-300 px-8">
              <TopRow setCurrentAgent={setCurrentAgent} />
            </div>
          </ShowFor>
        </div>

        <div className="-mx-8 overflow-x-auto">
          <div className="min-w-300 px-8">
            <WorkspacePreview />
          </div>
        </div>

        <div className="-mx-8 overflow-x-auto">
          <div className="min-w-300 px-8">
            <FlowCategoryPreview />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommandCenter;
